import { alpha, CardContent, IconButton, styled } from '@mui/material';

export const CardIcon = styled('div')(({ theme, bgColor = '' }) => ({
    background: bgColor || theme.palette.gray[100],
    // color: alpha(theme.palette.common.darkCharcoal, 0.6),
    width: '2rem',
    height: '2rem',
    minWidth: '2rem',
    minHeight: '2rem',
    marginRight: theme.typography.generic.medium,

    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',

    // padding: theme.typography.generic.xSmall,

    borderRadius: theme.typography.borderRadius.round,

    // fontSize: theme.typography.customFontSize.xLarge,
    // marginBottom: theme.typography.generic.medium,

    // '& svg': {
    //     width: 24,
    //     height: 24,
    // },
}));

export const CardContentStyled = styled(CardContent)(({ theme }) => ({
    display: 'flex',
    padding: theme.typography.generic.xLarge,

    '&:last-child': {
        padding: theme.typography.generic.xLarge,
    },
}));

export const CardButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    height: '60px',
    width: '60px',
    zIndex: 2,

    color: theme.palette.text.secondary,
    background: alpha(theme.palette.background.paper, 1),

    '&:hover': {
        background: alpha(theme.palette.background.paper, 1),
    },

    '& svg': {
        height: 20,
        width: 20,
    },

    '&.checked': {
        background: '#50AD648F',
        pointerEvents: 'none',

        '& svg': {
            color: theme.palette.text.inverse,
        },
    },
}));

export const CurveButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: '-8px',
    right: '0',
    height: '65px',
    width: '65px',
    zIndex: 2,

    color: theme.palette.text.secondary,
    background: alpha(theme.palette.background.paper, 1),

    '&:hover': {
        background: alpha(theme.palette.background.paper, 1),
    },

    '& svg': {
        height: 20,
        width: 20,
    },

    '&.checked': {
        background: '#50AD648F',
        pointerEvents: 'none',

        '& svg': {
            color: theme.palette.text.inverse,
        },
    },
}));
